"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditorControlsCheckbox = exports.CheckboxStateWrapper = void 0;
var React = require("react");
var csod = require("player-core");
var ViewSF_1 = require("./ViewSF");
var Checkbox_1 = require("player-editor-controls/controls/Checkbox");
Object.defineProperty(exports, "EditorControlsCheckbox", { enumerable: true, get: function () { return Checkbox_1.Checkbox; } });
var CheckboxStateWrapper = (function (_super) {
    __extends(CheckboxStateWrapper, _super);
    function CheckboxStateWrapper(props) {
        var _this = _super.call(this, props) || this;
        _this.packageName = 'player-application-workflow';
        _this._renderView = _this._renderView.bind(_this);
        _this.viewSF = ViewSF_1.viewSF.apply(_this);
        _this.viewSF.constructor && _this.viewSF.constructor.apply(_this, arguments);
        _this._trackers = {};
        if (typeof csod.context.tracking !== 'undefined') {
            var monikerCallback_1 = function (moniker, eventName) {
                var evt = document.createEvent("Event");
                evt.initEvent("player-" + moniker + "-" + eventName, true, false);
                window.dispatchEvent(evt);
            };
            for (var reporter in csod.context.tracking) {
                var _loop_1 = function (moniker) {
                    var events = csod.context.tracking[reporter][moniker];
                    var _loop_2 = function (i, l) {
                        var event_1 = events[i];
                        var monikerKey = moniker + '.' + event_1;
                        if (typeof this_1._trackers[monikerKey] === 'undefined')
                            this_1._trackers[monikerKey] = function () { monikerCallback_1(moniker, event_1); };
                    };
                    for (var i = 0, l = events.length; i < l; i++) {
                        _loop_2(i, l);
                    }
                };
                var this_1 = this;
                for (var moniker in csod.context.tracking[reporter]) {
                    _loop_1(moniker);
                }
            }
        }
        return _this;
    }
    CheckboxStateWrapper.prototype.componentDidMount = function () {
        this.viewSF.mounted && this.viewSF.mounted.apply(this, arguments);
    };
    CheckboxStateWrapper.prototype.componentWillReceiveProps = function (nextProps) {
        this.viewSF.willReceiveProps && this.viewSF.willReceiveProps.apply(this, arguments);
    };
    CheckboxStateWrapper.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        if (this.viewSF.shouldUpdate)
            return this.viewSF.shouldUpdate.apply(this, arguments);
        else
            return true;
    };
    CheckboxStateWrapper.prototype.componentDidUpdate = function (prevProps, prevState) {
        this.viewSF.didUpdate && this.viewSF.didUpdate.apply(this, arguments);
    };
    CheckboxStateWrapper.prototype.componentWillUnmount = function () {
        this.viewSF.unmount && this.viewSF.unmount.apply(this, arguments);
    };
    CheckboxStateWrapper.prototype._proxyTrackEvent = function (moniker, eventID, eventName) {
        var params = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            params[_i - 3] = arguments[_i];
        }
        var args = [];
        for (var i = 3; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        var monikerKey = moniker + '.' + eventID;
        var monikerCallback = this._trackers[monikerKey] || function () { };
        return this._processEvent(eventName, args, 4, monikerCallback);
    };
    CheckboxStateWrapper.prototype._proxyEvent = function (eventName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var args = [];
        for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        return this._processEvent(eventName, args, 2, function () { });
    };
    CheckboxStateWrapper.prototype._processEvent = function (eventName, args, repeaterArgIndex, callback) {
        args = pushAndShiftArgs(args, repeaterArgIndex);
        if (typeof this.viewSF.events[eventName] === 'function') {
            var self_1 = this;
            return function proxy() {
                var combinedArgs = [].slice.call(arguments).concat(args);
                self_1.viewSF.events[eventName].apply(self_1, combinedArgs);
                csod.lastEventDate = new Date();
                callback();
            };
        }
        else {
            return function noFunc() {
                if (eventName) {
                    csod.logger.warn(eventName + ' is not a valid function. Please check for typos.');
                    csod.lastEventDate = new Date();
                }
                callback();
            };
        }
    };
    CheckboxStateWrapper.prototype._renderView = function () {
        var _this = this;
        var PlayerVisible = csod.engine.controls.Player.Visible;
        var PlayerSwitch = csod.engine.controls.Player.Switch;
        var root_handler = function () {
            return [
                React.createElement(Checkbox_1.Checkbox, { key: 0, isEnabled: _this.props.isEnabled, showLabel: _this.props.showLabel, label: _this.props.label, isChecked: _this.state.isChecked, id: _this.props.id, tag: _this.props.tag, errorMessage: _this.state.errorMessage, onChange: _this._proxyEvent("onChange") })
            ];
        };
        return root_handler();
    };
    CheckboxStateWrapper.prototype.render = function () {
        return (React.createElement("div", { className: "p-viewSF-checkboxstatewrapper" }, this._renderView()));
    };
    CheckboxStateWrapper.defaultProps = {
        id: undefined, label: '', tag: '', isChecked: false, isEnabled: true, showLabel: false, errorMessage: ' ', ariaLabeledBy: '',
        onChange: function () { }
    };
    return CheckboxStateWrapper;
}(React.Component));
exports.CheckboxStateWrapper = CheckboxStateWrapper;
function pushAndShiftArgs(args, repeaterArgIndex) {
    if (args[repeaterArgIndex] === 'repeaterArgs') {
        args.push(args.shift());
        args.push(args.shift());
        args.shift();
        pushAndShiftArgs(args, repeaterArgIndex);
    }
    return args;
}
if (!window["__LOCALES__"])
    window["__LOCALES__"] = {};
window["__LOCALES__"]["CheckboxStateWrapper"] = undefined;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/CheckboxStateWrapper/CheckboxStateWrapper.js
// module id = 333
// module chunks = 0 1